var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingUpGcCsInIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.804 29.0853C9.42809 28.1911 7.35331 26.6435 5.81894 24.6211C4.28458 22.5986 3.35313 20.1836 3.13202 17.6547H8.89202C8.87006 21.6511 9.87261 25.5865 11.804 29.0853ZM21.8107 17.6547C21.568 24.9413 18.912 29.932 16.5134 29.932C14.1134 29.932 11.4587 24.9413 11.2147 17.6547H21.8107ZM29.868 17.6547C29.652 20.1871 28.721 22.606 27.1833 24.6297C25.6456 26.6535 23.5646 28.1986 21.1827 29.0853C23.1249 25.5902 24.1325 21.6531 24.108 17.6547H29.868ZM29.868 15.3453H24.108C24.1347 11.3453 23.128 7.40933 21.1827 3.91466C23.5655 4.79997 25.6474 6.34478 27.1852 8.36876C28.7231 10.3928 29.6536 12.8124 29.868 15.3453ZM21.8107 15.3453H11.2147C11.4587 8.04533 14.1134 3.06799 16.5134 3.06799C18.912 3.06799 21.5547 8.04533 21.8107 15.3453ZM11.804 3.97999C9.8706 7.47753 8.8679 11.413 8.89202 15.4093H3.13202C3.34871 12.8791 4.2785 10.4623 5.81347 8.43927C7.34844 6.41625 9.42565 4.87 11.804 3.97999Z",
    fill: "#3B54A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingUpGcCsInIndia);
export default __webpack_public_path__ + "static/media/Setting_up_GCCs_in_India.363087a66276895837a937bdfc31c24d.svg";
export { ForwardRef as ReactComponent };